import { MainApiResult, MainApiRoute } from 'hooks/useMainApi'
import EchodexTable from 'components/EchodexTable/EchodexTable'
import { CircleLoader } from '@echodex/uikit'

interface Props {
    histories: MainApiResult[MainApiRoute.GET_AIRDROP_USER_INFO]['histories'] | undefined
}

const PointHistoryTable = ({ histories }: Props) => {
    if (!histories)
        return (
            <div className="flex-center">
                <CircleLoader size="30px" />
            </div>
        )
    return (
        <div className="max-h-[calc(100%-72px)] min-h-[calc(100%-72px)] overflow-hidden overflow-x-auto overflow-y-auto ">
            <div className="max-sm:min-w-[130%]">
                <EchodexTable thead={THEAD} sticky>
                    {histories.map((item) => {
                        return (
                            <>
                                <tr className=" even:bg-gray odd:bg-backgroundAlt2" key={item.id}>
                                    <td>
                                        <div className="pl-4">
                                            {new Date(item.created_at).toLocaleDateString('en-UK')}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="fa-center gap-[8px]">
                                            {item.type}
                                            {item.type === 'LIQUIDITY_V3' && (
                                                <span className="px-1 text-xs text-black rounded-xl bg-pri w-fit">
                                                    x2
                                                </span>
                                            )}
                                        </div>
                                    </td>
                                    <td>
                                        <div>${Number(item.amount_usd).toFixed(4)}</div>
                                    </td>
                                    <td>
                                        <div className="pl-3">
                                            <div className="p-1 rounded-md text-pri min-w-[50px] max-w-[100px] flex-center bg-[#2a3839]">
                                                +{Number(item.point).toFixed(2)}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </>
                        )
                    })}
                </EchodexTable>
            </div>
        </div>
    )
}

type thead = {
    name: string
    width?: string
}
const THEAD: thead[] = [
    {
        name: 'Date',
    },
    {
        name: 'Type',
    },
    {
        name: 'Total Value',
    },
    {
        name: 'Point Received',
    },
]

export default PointHistoryTable
